import React from 'react';
import { inject } from 'mobx-react';
import { PiSparkleFill } from 'react-icons/pi';

import { LinkButton, Tag } from 'core/components';

import { getInvestigationStatusConfig } from 'app/stores/ai/investigationStatus';
import LabelValue from 'app/views/metrics/components/LabelValue';

const AiInvestigationContextItem = ({ context, labelWidth = 150, $kaizen }) => {
  const ai = context?.ai_investigation;

  if (!ai) {
    return null;
  }

  const { investigation_id: investigationId, status, short_summary: shortSummary } = ai;

  if (!investigationId) {
    return null;
  }

  const statusConfig = getInvestigationStatusConfig(status);

  return (
    <>
      <LabelValue
        label="AI Investigation"
        labelWidth={labelWidth}
        value={
          <LinkButton
            icon={PiSparkleFill}
            small
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              $kaizen.openSessionInCopilot(investigationId);
            }}
          >
            Open Details
          </LinkButton>
        }
      />
      {shortSummary && <LabelValue label="Summary" labelWidth={labelWidth} value={shortSummary} />}
      <LabelValue
        label="Status"
        labelWidth={labelWidth}
        value={
          <Tag intent={statusConfig.intent} small>
            {statusConfig.label}
          </Tag>
        }
      />
    </>
  );
};

export default inject('$kaizen')(AiInvestigationContextItem);
